define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/heading/Boolean",
	"csi/html",
	"csi/locale",
	"csi/types",
	"csi/xml"
], function(declare, csi, _, BooleanRen, html, locale, types, xml) {

	return declare(BooleanRen, {
		/**
		 * @override
		 * Construct comment containing list of tracking changes for PartMaterial
		 */
		_getComment(ctx, h) {
			var value = xml.nodeGetAttributeValue(ctx.getNode(), xml.idGetComment(h.m_id));
			if (!value) {
				return;
			}

			try {
				// value should be in JSON format for most recent releases, but could originally have been rich text
				var changes = JSON.parse(value).data;
				changes = csi.sort(changes, "date");
				value = _.reduce(changes, function(memo, com) {
					// tracking change dates are already in milliseconds
					memo += com.author + " " + types.formatTime(com.date) + ": ";

					var bColor = com.bomColorId != null;
					var subject = locale.typeId(bColor ? "PartMaterialColor" : "PartMaterial", com.attrid);
					if (bColor) {
						subject = com.bomColorId + ": " + subject;
					}

					var params = [subject];
					if (com.oldValue.length)
						params.push(com.oldValue);
					if (com.newValue.length)
						params.push(com.newValue);
					memo += locale.resource(com.resid, params) + "<br>";

					return memo;
				}, "");
			} catch (ex) {
				// if comment is in old rich text format, then check for any valid content
				if (!value.innerText) {
					return null;
				}
			}

			return value;
		}
	});
});